/* eslint-disable @typescript-eslint/no-explicit-any */
export type LanguageStore = {
  language: SupportedLanguages,
  availableLanguages: AvailableLanguage[],
  strings: any,
  isFetching: boolean,
};

export type AvailableLanguage = {
  code: SupportedLanguages,
  name: string,
};

export enum SupportedLanguages {
  EN = 'en',
  NL = 'nl',
}

export type LanguageActionType = any;
